let overlay = document.querySelector('[data-id="mobile-qty-overlay"]');
let modal = document.querySelector('[data-id="mobile-qty-main"]');
let variants = document.querySelectorAll('[data-id="product-variants"]');
let variantsArr = [];

let quantityInput = document.querySelector('quantity-input.qqty'); // desktop <quantity-input>
let quantityInputMobile = document.querySelector('quantity-input.mobileqqty '); // mobile  <quanitty-input>

let quantitySelector = document.querySelector(".mainqtyinput");
let mobileQuantitySelector = quantityInputMobile.querySelector('.mobilemainqtyinput'); // mobile input

let variantPrice = document.querySelectorAll(".product_price");
let clickBtn = document.querySelector("#add-to-bag");
let viewCartBtn = document.querySelector('[data-id="view-cart"]');
let quantityBtns = document.querySelectorAll(".qqty .quantity__button");

let minusBtn = quantityInput.querySelector('.quantity__button[name="minus"]');
let mobileMinusBtn = quantityInputMobile.querySelector('.quantity__button[name="minus"]');

let plusBtn = quantityInput.querySelector('.quantity__button[name="plus"]');
let mobilePlusBtn = quantityInputMobile.querySelector('.quantity__button[name="plus"]');

let btnWrapper = document.querySelector('[data-id="atcContainer"]');
let mobileQty = document.querySelector('[data-id="qty"]');
let mobileQtyInput = document.querySelector(".mobileqqty .mobilemainqtyinput"); 
let mobileVariantDeleteBtn = document.querySelector('[data-id="mobile-variant-delete"]');
let mobileQuantityBtns = document.querySelectorAll(".mobileqqty .quantity__button");
let upperErrorMsg = document.querySelector(".newErrorMessage");
let lowerErrorMsg = document.querySelector(".product-form__error-message");
let mainFormBtn = document.querySelector('[data-id="form-atc-btn"]');
let mainFormBtnHolder = document.querySelector('[data-id="form-atc-holder"]');
let mobile_sticky_atc = document.querySelector('.mobile_qty_atc_flex .mobile-sticky-atb');
let mobile_view_cart = document.querySelector('[data-id="mobile-view-cart"]');
let errorHolderDiv = document.getElementById('newErrorWrapper');


variants.forEach((variant) => {
  let inventoryQty = variant.getAttribute("variant-quantity");
  let variantID = variant.getAttribute("variant-id");
  let cartQty = variant.getAttribute("variant-cart-quantity");
  let variantPrice = variant.getAttribute("variant-price");
  let productCartName = variant.getAttribute("product-title");

  let variantObject = {
    id: variantID,
    inventoryQty: inventoryQty,
    cartQty: cartQty,
    variantPrice: variantPrice,
    variantCartName: productCartName,
  };

  variantsArr.push(variantObject);
});

fetch("/cart.js")
  .then((data) => data.json())
  .then((cartObj) => {
    cartObj.items.forEach((item) => {
      let matchingVariant = variantsArr.find((variant) => variant.id == item.id);
      if (matchingVariant) matchingVariant.key = item.key;
      // console.log(item.key);
    });
  });

function onVariantClick(event) {

  // event.preventDefault();
  upperErrorMsg.innerText = "";
  lowerErrorMsg.innerText = "";
  if(!errorHolderDiv.classList.contains('hidden')) errorHolderDiv.classList.add('hidden')
  clickedVariant = event.target;
  clickedId = clickedVariant.getAttribute("variant-id");
  let variantInObj = variantsArr.find((variant) => variant.id == clickedId);

  if(parseInt(variantInObj.inventoryQty) <= 0) {
    toHideMainSoldOutBtn();
  } else {
    toShowMainSoldOutBtn();
  }

  let sizeChartPrice = document.querySelector(".sizechartPrice");
  if (sizeChartPrice) sizeChartPrice.innerText = variantInObj.variantPrice;
  renderVariantInfo(variantInObj);

  if (Number(variantInObj.cartQty) == 0) {
    variantNotInCart(variantInObj);
  } else {
    variantInCart(variantInObj);
  }

  if (screen.width < 986) {
    document.querySelector('.mobile_qty_atc_flex  .mobileqqty').classList.add("flex");
    // .style.display = 'flex';
  }
}

function variantNotInCart(variant) {

  quantityBtns.forEach((btn) => {
    if (btn.classList.contains("disabled")) { 
      btn.classList.remove("disabled");
      btn.disabled = null;
    }
  });


  mobileQuantityBtns.forEach((btn) => {
    if (btn.classList.contains('disabled')) {
      btn.classList.remove('disabled')
      btn.disabled = null;
    };
  });

  quantitySelector.setAttribute("request-type", "add");
  quantitySelector.value = 1;
  quantitySelector.setAttribute("data-cart-quantity", variant.cartQty);
  quantitySelector.setAttribute("selected-variant-id", variant.id);
  variant.inventoryQty <= 10 ? quantitySelector.setAttribute("max", variant.inventoryQty) : quantitySelector.setAttribute("max", "10");
  
  mobileQuantitySelector.setAttribute('request-type', 'add');
  mobileQuantitySelector.value = 1;
  mobileQuantitySelector.setAttribute('data-cart-quantity', variant.cartQty);
  mobileQuantitySelector.setAttribute('selected-variant-id', variant.id);
  variant.inventoryQty <= 10 ? mobileQuantitySelector.setAttribute('max', variant.inventoryQty) : mobileQuantitySelector.setAttribute('max', '10');
  
  addRequestBtn();

  if (!minusBtn.classList.contains("disabled")){ 
    minusBtn.disabled = true;
    minusBtn.classList.add("disabled");
  }

  if (!mobileMinusBtn.classList.contains("disabled")){
     mobileMinusBtn.disabled = true;
     mobileMinusBtn.classList.add("disabled");
  }

  if (window.innerWidth <= 985) {
    if (btnWrapper.classList.contains("animate-atb")) {
      btnWrapper.classList.remove("animate-atb");
    }
    if (btnWrapper.classList.contains("animate-added")) {
      btnWrapper.classList.remove("animate-added");
    }
    if (btnWrapper.classList.contains("mobile")) {
      btnWrapper.classList.remove("mobile");
    }
    mobileQty.innerText = "1";
    mobileQtyInput.value = "1";
  }
}

function variantInCart(variant) {

  quantityBtns.forEach((btn) => {
    if (Number(variant.cartQty) < 10 && Number(variant.cartQty) < Number(variant.inventoryQty) && btn.classList.contains("disabled")){
      btn.classList.remove("disabled");
      btn.disabled = true;
    }
  });

  mobileQuantityBtns.forEach((btn) => {
    if (Number(variant.cartQty) < 10 && Number(variant.cartQty) < Number(variant.inventoryQty) && btn.classList.contains('disabled')) {
      btn.classList.remove('disabled')
      btn.disabled = true;
    };
  });

  if (!Number(variant.cartQty === 10) && Number(variant.cartQty < variant.inventoryQty)){
    plusBtn.disabled = null;
    plusBtn.classList.remove('disabled');
    mobilePlusBtn.disabled = null;
    mobilePlusBtn.classList.remove('disabled');
  }

  if(Number(variant.cartQty) === Number(variant.inventoryQty)){
    plusBtn.disabled = true;
    plusBtn.classList.add('disabled');
    mobilePlusBtn.disabled = true;
    mobilePlusBtn.classList.add('disabled');
  }

  if (Number(variant.cartQty > 1)){ 
    minusBtn.classList.remove("disabled");
    minusBtn.disabled = null;
    mobileMinusBtn.classList.remove('disabled');
    mobileMinusBtn.disabled = null;
  }
  
  if(Number(variant.cartQty === 10)){
    plusBtn.disabled = true;
    plusBtn.classList.add('disabled');
  }

  quantitySelector.setAttribute("request-type", "change");
  quantitySelector.value = variant.cartQty;
  quantitySelector.setAttribute("data-cart-quantity", variant.cartQty);
  quantitySelector.setAttribute("selected-variant-id", variant.id);
  variant.inventoryQty <= 10 ? quantitySelector.setAttribute("max", variant.inventoryQty) : quantitySelector.setAttribute("max", "10");
 
  mobileQuantitySelector.setAttribute('request-type', 'change');
  mobileQuantitySelector.value = variant.cartQty;
  mobileQuantitySelector.setAttribute('data-cart-quantity', variant.cartQty);
  mobileQuantitySelector.setAttribute('selected-variant-id', variant.id);
  variant.inventoryQty <= 10 ? mobileQuantitySelector.setAttribute('max', variant.inventoryQty) : mobileQuantitySelector.setAttribute('max', '10');

  changeRequestBtn();

  if (window.innerWidth <= 985) {
    if (!btnWrapper.classList.contains("animate-atb")) {
      btnWrapper.classList.add("animate-atb");
    }
    if (!btnWrapper.classList.contains("animate-added")) {
      btnWrapper.classList.add("animate-added");
    }
    if (!btnWrapper.classList.contains("mobile")) {
      btnWrapper.classList.add("mobile");
    }
    mobileQty.innerText = variant.cartQty;
    mobileQtyInput.value = variant.cartQty;
  }
}

function addRequestBtn() {

  if (screen.width > 985) {
    clickBtn.closest('.atc-container').style.display = 'block';
  } else { 
    mobile_sticky_atc.querySelector('.title.atbText').textContent = 'ADD TO BAG';
    mobile_sticky_atc.style.display = 'flex';
    mobile_view_cart.style.display = 'none';
    //mobile code
  }

  clickBtn.innerText = "Add to bag";

  clickBtn.style.display = 'block';
  if(viewCartBtn) viewCartBtn.classList.add('hidden');

  mainFormBtn.innerText = "ADD TO BAG";
  if (clickBtn.classList.contains("no_click")) clickBtn.classList.remove("no_click");
  if (mainFormBtnHolder.classList.contains("no_click")) mainFormBtnHolder.classList.remove("no_click");
}

function changeRequestBtn() {
  
  if(clickBtn)clickBtn.innerText = 'added';
  
  clickBtn.style.display = 'none';

  if (screen.width > 985) {
    clickBtn.closest('.atc-container').style.display = 'none';
    viewCartBtn.classList.remove('hidden');
  } else {
    mobile_sticky_atc.style.display = 'none';
    mobile_view_cart.style.display = 'block';
  }
  
  mainFormBtn.innerText = "ADDED";
  document.querySelector('[data-id="form-atc-holder"]').style.display = 'none';

  if (!clickBtn.classList.contains("no_click")) clickBtn.classList.add("no_click");
  if (!mainFormBtnHolder.classList.contains("no_click")) mainFormBtnHolder.classList.add("no_click");
}

function renderVariantInfo(variant) {
  variantPrice.forEach((price) => {
    price.innerText = variant.variantPrice;
  });
}

function quantityChange(event) {

  console.log("quantityChange called");
  clickBtn.closest('.atc-container').style.display = 'block';
  clickBtn.style.display = 'block';
  viewCartBtn.classList.add('hidden');

  // document.querySelector('[data-id="form-atc-holder"]').style.display = 'block';

  let quantityInput = event.target.parentElement.querySelector(".mainqtyinput");
  let variantSelectedToUpdate = quantityInput.getAttribute("selected-variant-id");
  let variantToChange = variantsArr.find((variant) => variant.id == variantSelectedToUpdate);
  let buttonFunction = event.target.getAttribute("name");
  
  if (Number(variantToChange.cartQty) === 0) {
    variantToChange.inventoryQty <= 10 ? quantityInput.setAttribute("max", variantToChange.inventoryQty) : quantityInput.setAttribute("max", "10");
  } else if (Number(variantToChange.cartQty) === 1) {
    if (buttonFunction === "plus") {
      variantToChange.inventoryQty <= 10 ? quantityInput.setAttribute("max", variantToChange.inventoryQty) : quantityInput.setAttribute("max", "10");
      quantityInput.setAttribute("request-type", "change");
      if (clickBtn.classList.contains("no_click")) clickBtn.classList.remove("no_click");
      if (mainFormBtnHolder.classList.contains("no_click")) mainFormBtnHolder.classList.remove("no_click");
      if (quantitySelector.getAttribute("request-type") === "change") {
        clickBtn.innerText = "update bag";
        mainFormBtn.innerText = "update bag";
      }
    } else {
      variantToChange.inventoryQty <= 10 ? quantityInput.setAttribute("max", variantToChange.inventoryQty) : quantityInput.setAttribute("max", "10");
    }
  } else if (
    parseInt(variantToChange.cartQty) > 1 && 
    parseInt(variantToChange.cartQty) < 10 && 
    parseInt(variantToChange.cartQty) < parseInt(variantToChange.inventoryQty)) 
  {
    variantToChange.inventoryQty <= 10 ? quantityInput.setAttribute("max", variantToChange.inventoryQty) : quantityInput.setAttribute("max", "10");
    quantityInput.setAttribute("request-type", "change");
    if (clickBtn.classList.contains("no_click")) clickBtn.classList.remove("no_click");
    if (mainFormBtnHolder.classList.contains("no_click")) mainFormBtnHolder.classList.remove("no_click");
    if (quantitySelector.getAttribute("request-type") === "change") {
      clickBtn.innerText = "update bag";
      mainFormBtn.innerText = "update bag";
    }
  } else {
    if (buttonFunction === "minus") {
      variantToChange.inventoryQty <= 10 ? quantityInput.setAttribute("max", variantToChange.inventoryQty) : quantityInput.setAttribute("max", "10");
      quantityInput.setAttribute("request-type", "change");
      if (clickBtn.classList.contains("no_click")) clickBtn.classList.remove("no_click");
      if (mainFormBtnHolder.classList.contains("no_click")) mainFormBtnHolder.classList.remove("no_click");
      if (quantitySelector.getAttribute("request-type") === "change") {
        clickBtn.innerText = "update bag";
        mainFormBtn.innerText = "update bag";
      }
    } else {
      variantToChange.inventoryQty <= 10 ? quantityInput.setAttribute("max", variantToChange.inventoryQty) : quantityInput.setAttribute("max", "10");
    }
  }
}

function mobileQuantityChange(event) {
  // console.log(event.target, "event");
  let quantityInput = document.querySelector(".mobileqqty .mobilemainqtyinput");
  let mobileQuantityInput = document.querySelector(".mobilemainqtyinput");
  let variantSelectedToUpdate = quantityInput.getAttribute("selected-variant-id");
  let variantToChange = variantsArr.find((variant) => variant.id == variantSelectedToUpdate);
  let buttonFunction = event.target.getAttribute("name");

  if (Number(variantToChange.cartQty == 0)) {

    variantToChange.inventoryQty <= 10 ? quantityInput.setAttribute("max", variantToChange.inventoryQty) : quantityInput.setAttribute("max", "10");
    variantToChange.inventoryQty <= 10 ? mobileQuantityInput.setAttribute("max", variantToChange.inventoryQty) : mobileQuantityInput.setAttribute("max", "10");
  } else if (Number(variantToChange.cartQty == 1)) {
    if (buttonFunction === "plus") {

      variantToChange.inventoryQty <= 10 ? quantityInput.setAttribute("max", variantToChange.inventoryQty) : quantityInput.setAttribute("max", "10");
      variantToChange.inventoryQty <= 10 ? mobileQuantityInput.setAttribute("max", variantToChange.inventoryQty): mobileQuantityInput.setAttribute("max", "10");
      quantityInput.setAttribute("request-type", "change");
      
    /*
      ┌─────────────────────────────────────────────────────────────────────────────────────────────────────────────────────┐
      │     Patch for Cart Quantity Update                                                                                  │
      └─────────────────────────────────────────────────────────────────────────────────────────────────────────────────────┘
    */
      document.querySelector('.mainqtyinput').setAttribute('request-type', 'change');
    /*
      ┌─────────────────────────────────────────────────────────────────────────────────────────────────────────────────────┐
      │     Patch for Cart Quantity Update                                                                                  │
      └─────────────────────────────────────────────────────────────────────────────────────────────────────────────────────┘
    */

      if (clickBtn.classList.contains("no_click")) clickBtn.classList.remove("no_click");
      if (mainFormBtnHolder.classList.contains("no_click")) mainFormBtnHolder.classList.remove("no_click");
       if (mobileQuantitySelector.getAttribute('request-type') === 'change') {
        mobile_view_cart.style.display = 'none';
        mobile_sticky_atc.style.display = 'flex';
        mobile_sticky_atc.querySelector('.title.atbText').textContent = 'UPDATE BAG';

        clickBtn.innerText = 'update bag';
        mainFormBtn.innerText = 'update bag';
      }
    } else {
      variantToChange.inventoryQty <= 10 ? quantityInput.setAttribute("max", variantToChange.inventoryQty) : quantityInput.setAttribute("max", "10");
      variantToChange.inventoryQty <= 10
        ? mobileQuantityInput.setAttribute("max", variantToChange.inventoryQty)
        : mobileQuantityInput.setAttribute("max", "10");
    }
  } else if (Number(variantToChange.cartQty > 1 && variantToChange.cartQty < 10)) {

    variantToChange.inventoryQty <= 10 ? quantityInput.setAttribute("max", variantToChange.inventoryQty) : quantityInput.setAttribute("max", "10");
    variantToChange.inventoryQty <= 10 ? mobileQuantityInput.setAttribute("max", variantToChange.inventoryQty) : mobileQuantityInput.setAttribute("max", "10");
    quantityInput.setAttribute("request-type", "change");


    document.querySelector('.mainqtyinput').setAttribute('request-type', 'change');


    if (clickBtn.classList.contains("no_click")) clickBtn.classList.remove("no_click");
    if (mainFormBtnHolder.classList.contains("no_click")) mainFormBtnHolder.classList.remove("no_click");
    if (mobileQuantitySelector.getAttribute("request-type") === "change") {
      mobile_view_cart.style.display = 'none';
      mobile_sticky_atc.querySelector('.title.atbText').textContent = 'UPDATE BAG';
      mobile_sticky_atc.style.display = 'flex';

      clickBtn.innerText = 'update bag';
      mainFormBtn.innerText = 'update bag';
    }
  } else {
    if (buttonFunction === "minus") {
      variantToChange.inventoryQty <= 10 ? quantityInput.setAttribute("max", variantToChange.inventoryQty) : quantityInput.setAttribute("max", "10");
      variantToChange.inventoryQty <= 10
        ? mobileQuantityInput.setAttribute("max", variantToChange.inventoryQty)
        : mobileQuantityInput.setAttribute("max", "10");
      quantityInput.setAttribute("request-type", "change");
      if (clickBtn.classList.contains("no_click")) clickBtn.classList.remove("no_click");
      if (mainFormBtnHolder.classList.contains("no_click")) mainFormBtnHolder.classList.remove("no_click");
      if (mobileQuantitySelector.getAttribute("request-type") === "change") {
        clickBtn.innerText = "update bag";
        mainFormBtn.innerText = "update bag";

        mobile_view_cart.style.display = 'none';
        mobile_sticky_atc.querySelector('.title.atbText').textContent = 'UPDATE BAG';
        mobile_sticky_atc.style.display = 'flex';
      }
    } else {
      variantToChange.inventoryQty <= 10 ? quantityInput.setAttribute("max", variantToChange.inventoryQty) : quantityInput.setAttribute("max", "10");
      variantToChange.inventoryQty <= 10
        ? mobileQuantityInput.setAttribute("max", variantToChange.inventoryQty)
        : mobileQuantityInput.setAttribute("max", "10");
    }
  }
}

function updateAddedVarinats(response) {
  let variantToUpdate = variantsArr.find((variant) => variant.id == response.variant_id);
  variantToUpdate.cartQty = response.quantity;
  variantToUpdate.key = response.key;
}

function updateChangedVarinats(response) {
  let updatedCartItems = response.items;
  updatedCartItems.find((item) => {
    variantsArr.find((variant) => {
      if (variant.id == item.variant_id) {
        variant.cartQty = item.quantity;
        variant.key = item.key;
      }
    });
  });
}

function updateDeletedVariants(id) {
  variantsArr.find((variant) => {
    if (variant.id == id) {
      variant.cartQty = "0";
      delete variant.key;
    }
  });
  let deletedItem = document.querySelector(`.upperSizes[variant-id="${id}"]`);
  // console.log(deletedItem);
  deletedItem.click();
  // console.log(id, "iddd");
  deletedItem.setAttribute('data-quantity-validation',0);
}

function updateMobileQty() {
  quantitySelector.value = mobileQtyInput.value;
  mobileQty.innerText = mobileQtyInput.value;
}

function deleteMobileVairant() {
  let variantToDelete = document.querySelector(".variant_innerWrapper input[type=radio]:checked+label");
  let variantToDeleteId = variantToDelete.getAttribute("variant-id");
  let variantDeletebtn = document.querySelector(`[data-delete-variant-id='${variantToDeleteId}']`);
  variantsArr.find((variant) => {
    let variantObj = variant.id == variantToDeleteId;
    if (variantObj) {
      // console.log(variant, "variantObj");
    }
    variantNotInCart(variant);
  });
  variantDeletebtn.click();
  // console.log(variantDeletebtn);
}

function maxQuantityMsg() {

  console.log("maxQuantityMsg called");

  let msgDiv = document.querySelector(".product-addedNotification");
  let msg = msgDiv.querySelector(".product-addedNotification .notification-tag");
  msg.innerText = "The max quantity of product is already in your bag.";
  msgDiv.style.display = "flex";
  setTimeout(removeMsg, 2000);
}

const submit_Button = document.querySelector(".clickpost-edd__submit-button");
const targetNode = document.querySelector(".clickpost-edd__container");
const config = { attributes: true, childList: true, subtree: true };
const callback = (mutationList, observerNew) => {
  for (const mutation of mutationList) {
    if (mutation.type === "attributes" && mutation.attributeName === "style") {
      sessionStorage.setItem("response_status", mutation.target.id);
      // console.log(mutation.target.id);
      //checkPincodeStatus();
    }
  }
};

// function checkPincodeStatus() {
//   const animationATB = document.querySelector('[data-id="atcContainer"]');
//   const formATB = document.querySelector('[data-id="form-atc-holder"]');
//   const sizeChartBtn = document.querySelector('[data-id="sizeChartAddBtn"]');
//   let sessionStorageResponse = sessionStorage.getItem("response_status");
//   if (sessionStorageResponse) {
//     let responseElement = document.getElementById(sessionStorageResponse);
//     if (responseElement.innerText.includes("not servicable")) {
//       if (!animationATB.classList.contains("buttonDisabled")) animationATB.classList.add("buttonDisabled");
//       if (!formATB.classList.contains("buttonDisabled")) formATB.classList.add("buttonDisabled");
//       if (!sizeChartBtn.classList.contains("buttonDisabled")) sizeChartBtn.classList.add("buttonDisabled");
//       quantityBtns.forEach((btn) => {
//         if (!btn.classList.contains("buttonDisabled")) btn.classList.add("buttonDisabled");
//       });
//     } else {
//       if (animationATB.classList.contains("buttonDisabled")) animationATB.classList.remove("buttonDisabled");
//       if (sizeChartBtn.classList.contains("buttonDisabled")) sizeChartBtn.classList.remove("buttonDisabled");
//       if (formATB.classList.contains("buttonDisabled")) formATB.classList.remove("buttonDisabled");
//       quantityBtns.forEach((btn) => {
//         if (btn.classList.contains("buttonDisabled")) btn.classList.remove("buttonDisabled");
//       });
//     }
//   } else {
//     return;
//   }
// }


// function closeMobileModal() {
//   let mobileModal = document.querySelector('[data-id="mobile-qty-overlay"]');
//   let selectedMobileVariant = document.querySelector(".variant_innerWrapper input[type=radio]:checked+label");
//   let selectedMobileVariantId = selectedMobileVariant.getAttribute("variant-id");
//   let docBody = document.body;
//   if (mobileModal.classList.contains("show-mobile-qty-overlay")) {
//     mobileModal.classList.remove("show-mobile-qty-overlay");
//     docBody.style.overflow = "scroll";
//   }
//   if (!btnWrapper.classList.contains("animate-atb")) {
//     btnWrapper.classList.add("animate-atb");
//   }
//   if (!btnWrapper.classList.contains("animate-added")) {
//     btnWrapper.classList.add("animate-added");
//   }
//   if (!btnWrapper.classList.contains("mobile")) {
//     btnWrapper.classList.add("mobile");
//   }
//   let mobileSelectedVariantInfo = variantsArr.find((variant) => variant.id == selectedMobileVariantId);
//   mobileQty.innerText = mobileSelectedVariantInfo.cartQty;
//   mobileQtyInput.value = mobileQty.innerText;
// }


// overlay.addEventListener("click", function (event) {
//   if (event.target === overlay) {
//     closeMobileModal();
//   }
// });

variants.forEach((variant) => {
  variant.addEventListener("click", () => {
    onVariantClick(event);
  });
});

quantityBtns.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    quantityChange(event);
  });
});

mobileQuantityBtns.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    mobileQuantityChange(event);
  });
});

mobileQtyInput.addEventListener("change", () => {
  updateMobileQty();
});

// mobileVariantDeleteBtn.addEventListener("click", () => {
//   deleteMobileVairant();
// });

const observerNew = new MutationObserver(callback);
submit_Button.addEventListener("click", async () => {
  observerNew.observe(targetNode, config);
});

window.addEventListener("DOMContentLoaded", () => {
  observerNew.observe(targetNode, config);
});

window.addEventListener("DOMContentLoaded", () => {
  checkUrl();
});

function checkUrl() {
  let url = window.location.href;
  if (url.includes("?variant")) {
    let two = url.split("?");
    two.splice(1, 1);
    let modifiedUrl = two.join("?");
    history.replaceState(null, null, modifiedUrl);

    if(document.querySelectorAll('[data-id="product-variants"]').length == 1){
      document.querySelector('[data-id="product-variants"]').click();
    }
    
    else{ 
      setTimeout(() => {
       let radioElement = document.querySelectorAll('.variant_innerWrapper input[type=radio]:checked+label');
       radioElement.forEach((ele)=> {
        ele.previousElementSibling.checked = false;
      })
     }, "2000");
    }
  } else {

    if(document.querySelectorAll('[data-id="product-variants"]').length == 1){
      document.querySelector('[data-id="product-variants"]').click();
    }
    

    return;
  }
}

function openCart() {
  document.querySelector('.header__icon--cart.custom-cart__icon').click();
}

function mainAtc_click() {
  document.querySelector('[data-id="addToBag"]').click();
}
